// Quem usa, gere, paga e edita o Programa de Indicações (#6196).
//
// ESPELHO das funções do banco (migration 20261020100000): fn_indicacao_usuario_crm,
// fn_indicacao_pode_gerir e fn_indicacao_pode_pagar. O banco é a regra de verdade —
// isto aqui só decide o que a tela mostra. Mudou lá, muda aqui.

import { ehComercialInterno } from '../departamentos.ts';

export const TRABALHAR_INDICACOES_PERMISSION = 'Trabalhar indicações';
export const PAGAR_RECOMPENSAS_PERMISSION = 'Pagar recompensas de indicação';

/** Lista de PERMISSÃO: papel novo entra sem acesso. */
export const PAPEIS_DO_PROGRAMA = [
  'adm', 'gerente', 'analista', 'vendedor', 'parceiro', 'vendedor_parceiro', 'gerente_parcerias',
] as const;

export interface PerfilIndicacao {
  role?: string | null;
  /** 'active' | 'inactive'. Ausente conta como ativo (perfis antigos sem o campo). */
  status?: string | null;
  departamento?: string | null;
  departamentos?: string[] | null;
  /** Função no Comercial (closer, bdr, hunter). Closer e BDR gerem o programa. */
  funcao_comercial?: string | null;
  permissions?: string[] | null;
}

const temPermissao = (p: PerfilIndicacao, permissao: string): boolean =>
  Array.isArray(p.permissions) && p.permissions.includes(permissao);

// Quem saiu da empresa fica com o papel antigo e status 'inactive' (ex.: um gerente que
// virou parceiro). O login é bloqueado à parte; isto é a segunda barreira.
const ativo = (p: PerfilIndicacao): boolean => (p.status ?? 'active') === 'active';

export function podeUsarIndicacoes(p?: PerfilIndicacao | null): boolean {
  return !!p && ativo(p) && (PAPEIS_DO_PROGRAMA as readonly string[]).includes(p.role ?? '');
}

/** Vê e registra tudo: adm, gerente, Closer e BDR (ou o antigo Comercial Interno), ou a permissão (pós-venda). */
export function podeGerirIndicacoes(p?: PerfilIndicacao | null): boolean {
  if (!p || !podeUsarIndicacoes(p)) return false;
  if (p.role === 'adm' || p.role === 'gerente') return true;
  return ehComercialInterno(p) || temPermissao(p, TRABALHAR_INDICACOES_PERMISSION);
}

/** Abre a aba Recompensas e marca pagamento. */
export function podePagarRecompensas(p?: PerfilIndicacao | null): boolean {
  if (!p || !podeUsarIndicacoes(p)) return false;
  return p.role === 'adm' || p.role === 'gerente' || temPermissao(p, PAGAR_RECOMPENSAS_PERMISSION);
}

/** Muda tipo e valor da recompensa do programa. */
export function podeEditarPrograma(p?: PerfilIndicacao | null): boolean {
  return !!p && podeUsarIndicacoes(p) && (p.role === 'adm' || p.role === 'gerente');
}
